import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CompaniesComponent } from './dashboard/crud/companies/companies.component';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { MdbScrollspyModule } from 'mdb-angular-ui-kit/scrollspy';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { MdbLoadingModule } from 'mdb-angular-ui-kit/loading';
import { MdbFileUploadModule } from 'mdb-angular-file-upload';
import { AppsComponent } from './dashboard/crud/apps/apps.component';
import { LogsComponent } from './dashboard/crud/logs/logs.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTreeviewModule } from 'mdb-angular-treeview';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';


import { ReactiveFormsModule } from '@angular/forms';
import { DocumentsComponent } from './dashboard/crud/documents/documents.component'; // Import ReactiveFormsModule
import { MdbChipsModule } from 'mdb-angular-ui-kit/chips';
import { CodeRequestComponent } from './dashboard/crud/code-request/code-request.component';
import { ListCodeRequestComponent } from './dashboard/crud/list-code-request/list-code-request.component';
import { BinnacleComponent } from './dashboard/crud/binnacle/binnacle.component';
import { ListBinnacleComponent } from './dashboard/crud/list-binnacle/list-binnacle.component';
import { WorkOrdersComponent } from './dashboard/crud/work-orders/work-orders.component';

@NgModule({
  declarations: [
    DashboardComponent,
    CompaniesComponent,
    AppsComponent,
    LogsComponent,
    DocumentsComponent,
    CodeRequestComponent,
    ListCodeRequestComponent,
    BinnacleComponent,
    ListBinnacleComponent,
    WorkOrdersComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    MdbTableModule,
    MdbScrollspyModule,
    MdbFormsModule,
    MdbModalModule,
    MdbLoadingModule,
    MdbFileUploadModule,
    MdbTabsModule,
    MdbCheckboxModule,
    MdbSelectModule,
    ReactiveFormsModule,
    MdbTreeviewModule,
    MdbChipsModule,
    MdbDatepickerModule
  ]
})
export class AdminModule { }